import React, { Component } from 'react';
import styles from './Footer.module.css';
import logo from '../images/logo-white.svg';
import { withRouter } from 'react-router-dom';

class Footer extends Component {
  render() {
        var extrahtml="";
         console.log(this.props.config);

    return (
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <div>
            <img src={logo} alt="logo" style={{ maxHeight: '32px', marginRight: '6px' }} />
            <span>Connected Apps</span>
          </div>
          {/* <div className={styles.names}>
            <div>Michiel Mayer</div>
            <div>Hans Schevers</div>
          </div> */}
        </div>
      </div>
    );
  }
}

Footer = withRouter(Footer);

export default Footer;
